import React, { CSSProperties } from 'react';
import SalvBigLogo from '../assets/img/salv.svg';
import SalvSmallLogo from '../assets/img/salv_small.svg';
import VyntraLogo from '../assets/img/vyntra_logo.png';
import './SalvLogo.scss';

type SalvLogoProps = {
  dark?: boolean;
  width?: number;
  small?: boolean;
  className?: string;
  whiteLabel?: boolean;
};

export const SalvLogo = ({ dark = false, small = false, width, className = '', whiteLabel = false }: SalvLogoProps) => {
  const type = dark ? 'dark' : 'light';
  const widthStyle = width ? width + 'px' : undefined;
  const LogoComponent = whiteLabel ? WhiteLabelBlock : small ? SmallLogo : BigLogo;

  return (
    <div data-testid='logo' className={`salv-logo ${type} ${className}`}>
      <LogoComponent style={{ width: widthStyle }} />
    </div>
  );
};

const BigLogo = ({ style }: { style?: CSSProperties }) => {
  return <SalvBigLogo style={style} className='p-r-12 p-l-12' />;
};

const WhiteLabelBlock = ({ style }: { style?: CSSProperties }) => {
  return <img src={VyntraLogo} alt='Vyntra' className='salv-logo-white-label' style={style} />;
};

const SmallLogo = SalvSmallLogo;
